import React from 'react';
import AntdProForm, { ProFormRadio } from '@ant-design/pro-form';
import { Card, Descriptions } from 'antd';
import 'react-quill/dist/quill.snow.css';
import PropTypes from 'prop-types';
import { EditOutlined } from '@ant-design/icons';
import AssignApproverModal from './AssignApproverModal';
import ProForm from './ProForm';
import { PrivateComponent } from '../auth';
import { APPLICATION_TYPES } from '../../constants/form';
import { HtmlInput } from '../input';

const approver = ({
  approverListingType,
  appointedApprover,
  applicationType,
  sequence,
  refetchQueries,
}) => {
  if (approverListingType === 'ASSIGN' && appointedApprover.role == null) {
    return (
      <Descriptions.Item label="Approver" labelStyle={{ alignItems: 'center' }}>
        To be assigned by PMS Admin{'  '}
        <PrivateComponent expectedScopeType={['ASSIGN_APPROVER']}>
          <AssignApproverModal
            applicationType={applicationType}
            sequence={sequence}
            refetchQueries={refetchQueries}
          />
        </PrivateComponent>
      </Descriptions.Item>
    );
  } else {
    const { role, faculty, department } = appointedApprover;
    const displayFacDept = department
      ? ` - ${department.name}`
      : faculty
      ? ` - ${faculty.name}`
      : '';

    return (
      <Descriptions.Item label="Approver" labelStyle={{ alignItems: 'center' }}>
        {`${role.name}${displayFacDept}`}
        <PrivateComponent expectedScopeType={['ASSIGN_APPROVER']}>
          <AssignApproverModal
            applicationType={applicationType}
            sequence={sequence}
            refetchQueries={refetchQueries}
            buttonText="Re-assign Approver"
            prefixIcon={<EditOutlined />}
          />
        </PrivateComponent>
      </Descriptions.Item>
    );
  }
};

const ApprovalForm = ({
  projectFrozen,
  step,
  onFinish,
  isCurrentAppointedApprover,
  loading,
  active,
  applicationType,
  refetchQueries,
}) => {
  const disabled =
    loading || !active || projectFrozen ? true : !isCurrentAppointedApprover;
  const [form] = AntdProForm.useForm();

  const { approverListingType, appointedApprover, sequence } = step;
  const initialValues = {
    approved: undefined,
    comment: '',
  };

  return (
    <>
      <Card type="inner" title={step.name}>
        <Descriptions>
          {approver({
            approverListingType,
            appointedApprover,
            sequence,
            applicationType,
            refetchQueries,
          })}
        </Descriptions>
        <ProForm
          form={form}
          onFinish={(value) => {
            value.comment = value.html;
            onFinish(value);
          }}
          initialValues={initialValues}
          loading={loading}
          hideBackButton={disabled}
          hideSubmitButton={disabled}
        >
          <ProFormRadio.Group
            name="approved"
            label="My Action"
            disabled={disabled}
            options={[
              {
                label: 'Approve',
                value: true,
              },
              {
                label: 'Reject',
                value: false,
              },
            ]}
            rules={[{ required: true, message: 'Please select!' }]}
          />
          <HtmlInput
            form={form}
            label="Comments"
            placeholder="Please Enter"
            required={true}
            requiredMessage="Please enter comment"
          />
        </ProForm>
      </Card>
    </>
  );
};

ApprovalForm.defaultProps = {
  isCurrentAppointedApprover: false,
  loading: true,
  refetchQueries: [],
  projectFrozen: false,
};

ApprovalForm.propTypes = {
  step: PropTypes.object.isRequired,
  onFinish: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  isCurrentAppointedApprover: PropTypes.bool.isRequired,
  applicationType: PropTypes.oneOf(APPLICATION_TYPES).isRequired,
  refetchQueries: PropTypes.array.isRequired,
  projectFrozen: PropTypes.bool.isRequired,
};

export default ApprovalForm;
